{
    "type": "object",
    "properties": {
        "_draftRefs": {
            "type": "array",
            "items": {
                "type": "object",
                "properties": {
                    "path": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "jsonPointer": {
                        "type": "string"
                    },
                    "namespace": {
                        "type": "string"
                    }
                }
            }
        },
        "_isDraftItem": {
            "type": "boolean",
            "default": true
        }
    },
    "additionalProperties": true,
    "required": ["_isDraftItem"]
}
